"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var ToolBar_1 = __importDefault(require("./ToolBar"));
var UrlTable_1 = __importDefault(require("./UrlTable"));
var EmptyState_1 = __importDefault(require("../EmptyState"));
var AppMargins_1 = require("../../../app/components/AppMargins");
var StatusBar_1 = __importDefault(require("./StatusBar"));
function UserLinkTable() {
    var initialised = (0, react_redux_1.useSelector)(function (state) {
        return state.user.initialised;
    });
    var urlCount = (0, react_redux_1.useSelector)(function (state) {
        return state.user.urlCount;
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(AppMargins_1.ApplyAppMargins, null,
            react_1.default.createElement(ToolBar_1.default, null)),
        react_1.default.createElement(StatusBar_1.default, null),
        !initialised && react_1.default.createElement("div", null),
        initialised &&
            (urlCount > 0 ? react_1.default.createElement(UrlTable_1.default, null) : react_1.default.createElement(EmptyState_1.default, { urlsFiltered: true }))));
}
exports.default = UserLinkTable;
